
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payrollsystem/privacy-policy",
      function () {
        return require("private-next-pages/payrollsystem/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payrollsystem/privacy-policy"])
      });
    }
  